@if (helpentryId > 0) {
  <div
    class="cw-module-card"
    [ngClass]="{
        hidden:
            allowEditHelpentry ||
            (!allowEditHelpentry && (documentsService.documentsCount > 0 || documentsService.documentsCount == null))
                ? false
                : true
    }">
    <phscw-documents
      class="global-help-documents"
      backendController="HelpDocuments"
      type="help"
      [displayGridId]="displayGridId"
      [gridDisplayedColumns]="displayColumns"
      [selectionDisplayedColumns]="uploadColumns"
      [entityId]="helpentryId"
      [allowFileUpload]="allowEditHelpentry">
      <!--Header-->
      <div class="cw-flex-row">
        <!-- Modul-Titel -->
        <h2>{{ 'GENERAL.DOCUMENTS' | translate }}</h2>
      </div>
    </phscw-documents>
  </div>
}
